import { ReactNode } from 'react';

export const ContainerWebinarInner = ({ children }: { children: ReactNode }) => <div className="px:4 md:px-6 pt-4 md:pt-10"> {children} </div>;
